import VolumeGrid from './VolumeGrid';
import { useFilteredVolumes } from './hooks/useFilteredVolumes';

import type { Volume } from '~/shared/types/api';

interface MatchingVolumesProps {
  volumes: Volume[];
  onCreateException?: (volumeId: string) => void;
  selectedVolumeType: 'supported' | 'notSupported';
  onVolumeTypeChange: (type: 'supported' | 'notSupported') => void;
  searchQuery: string;
  onSearchChange: (value: string) => void;
  isLoading?: boolean;
}

export default function MatchingVolumes({
  volumes,
  onCreateException,
  selectedVolumeType,
  onVolumeTypeChange: _onVolumeTypeChange,
  searchQuery,
  onSearchChange: _onSearchChange,
  isLoading = false,
}: MatchingVolumesProps) {
  const filteredVolumes = useFilteredVolumes({
    volumes,
    selectedVolumeType,
    searchQuery,
  });

  return (
    <div className="flex flex-col gap-5 py2 h-full overflow-y-auto side-panel-scrollbar ">
      <VolumeGrid
        volumes={filteredVolumes}
        searchQuery={searchQuery}
        onCreateException={onCreateException}
        isLoading={isLoading}
      />
    </div>
  );
}
